
import React, { useState, useEffect } from 'react'
import Swal from "sweetalert2";
import Axios from 'axios';
import Select from 'react-select';
import { API_BASE_URL, INSERT_STAFF, GET_DDL } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddStaff = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [selectedEmpType, setSelectedEmpType] = useState([]);
    const [selectedGender, setSelectedGender] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
        } else {
        console.log("User data not found in sessionStorage");
        }
    }, []);

    const [formData, setFormData] = useState(
        {
            OrgId: userDataSession.OrgId,
            Name: "",
            Code: "",
            MobileNo: "",
            Type: selectedEmpType.value,
            CreatedBy: userDataSession.UserId,
            Gender: selectedGender.value
        }
    );

    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        setSubmitBtnLoading(true);
        formData.OrgId = userDataSession.OrgId,
        formData.CreatedBy = userDataSession.UserId,
        formData.Type = selectedEmpType.value,
        formData.Gender = selectedGender.value,

        console.log(formData, 'ffffff');

        Axios.post(`${API_BASE_URL}${INSERT_STAFF}`, formData)
            .then(response => {
                console.log(response.data, 'rrrrrrrr');

                if (response.data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);

                    // Show success message
                    Swal.fire({
                        title: `Staff added Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        // Reload the page after the user acknowledges the success message
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                        if (userDataSession && userDataSession.OrgId) {
                          Axios.get(`${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`)
                            .then(response => {
                              if (response.data) {
                                const allData = response.data.ResultData;
                      
                                // Define the DDL names to filter
                                const ddlNames = ['Supplier', 'CATEGORY', 'Subcategories', 'Products', 'variantypes', 'TAX', 'Stores', 'BRAND', 'Roles', 'Staff', 'Customers', 'UNITS'];
                      
                                // Iterate through each DDL name, filter data, and save to session storage
                                ddlNames.forEach(name => {
                                  const filteredData = allData.filter(item => item.DDLName === name);
                                  sessionStorage.setItem(`filteredDDLData_${name}`, JSON.stringify(filteredData));
                                });
                      
                                console.log('Filtered data saved successfully');
                              } else {
                                console.error('Error fetching data:', response.data);
                              }
                            })
                            .catch(error => {
                              console.error('Error fetching data:', error);
                            });
                        }
                } else {
                    setSubmitBtnLoading(false);

                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }

                setFormData({
                    ...formData,
                    Name: "",
                    Description: "",
                    Code: ""
                });
            })

            .catch(error => {
                setSubmitBtnLoading(false);
                // Handle error
                console.error('Error adding category:', error);
            });
    };

    const empTypes = [
        { value: '1', label: 'Sales Representavative' },
        { value: '2', label: 'Manager' },
        { value: '3', label: 'Staff' },
        { value: '4', label: 'Admin' },
    ];

    const genderData = [
        { value: '1', label: 'Male' },
        { value: '0', label: 'Female' },
    ];

    const handleEmpTypeChange = (selectedOption) => {
        setSelectedEmpType(selectedOption);
    };

    const handleGenderChange = (selectedOption) => {
        setSelectedGender(selectedOption);
    };

    return (
        <div>
            {/* Add Staff */}
             {(submitBtnLoading)&&(<SpinLoader/>)}
            <div className="modal fade" id="add-staff">
                <div className="modal-dialog modal-dialog-centered custom-modal-two mt-5"  style={{ maxWidth: '40%' }}>
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0" >
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Add Staff</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close d-flex ms-auto"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Enter staff name'
                                                    name="Name"
                                                    value={formData.Name || ''}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Enter code'
                                                    name="Code"
                                                    value={formData.Code || ''}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Mobile No</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder='Enter mobile no'
                                                    name="MobileNo"
                                                    value={formData.MobileNo || ''}
                                                    onChange={handleChange}
                                                    // required
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Gender</label>
                                                <Select
                                                    options={genderData} 
                                                    className="select" 
                                                    placeholder="Choose"
                                                    onChange={handleGenderChange}
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-lg-6 col-md-6">
                                                <label className="form-label">Employee Type<span className="fw-bold text-danger">*</span></label>
                                                <Select
                                                    options={empTypes} 
                                                    className="select" 
                                                    placeholder="Choose"
                                                    onChange={handleEmpTypeChange}
                                                />
                                            </div>
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                     disabled={submitBtnLoading}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-submit"
                                                     disabled={submitBtnLoading}
                                                >
                                                    {submitBtnLoading ? 'Submitting..' : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Staff */}
        </div>
    )
}

export default AddStaff
